<template>
  <div v-if="gardenMap" class="gp-map-controls">
    <rui-toolbar class="rui-toolbar--vertical">
      <rui-button icon="zoom-in" :title="$t('js.map_controls.zoom_in')" @click="gardenMap.zoom(+0.5)" />
      <rui-button icon="zoom-out" :title="$t('js.map_controls.zoom_out')" @click="gardenMap.zoom(-0.5)" />
      <rui-button icon="arrows-in-cardinal" :title="$t('js.map_controls.reset_view')" @click="gardenMap.resetView()" />

      <template v-if="expanded">
        <rui-button icon="arrow-counter-clockwise" :title="$t('js.map_controls.rotate_counter_clockwise')" @click="gardenMap.rotate(-1)" />
        <rui-button icon="arrow-clockwise" :title="$t('js.map_controls.rotate_clockwise')" @click="gardenMap.rotate(1)" />
        <rui-button icon="arrow-up" :title="$t('js.map_controls.pan_up')" @click="gardenMap.pan(0, 1)" />
        <rui-button icon="arrow-down" :title="$t('js.map_controls.pan_down')" @click="gardenMap.pan(0, -1)" />
        <rui-button icon="arrow-left" :title="$t('js.map_controls.pan_left')" @click="gardenMap.pan(-1, 0)" />
        <rui-button icon="arrow-right" :title="$t('js.map_controls.pan_right')" @click="gardenMap.pan(1, 0)" />
      </template>

      <rui-help-button class="gp-map-controls__help-button">
        <!-- eslint-disable vue/no-v-html -->
        <table>
          <tbody>
            <tr>
              <th>{{ $t('js.map_controls.help.zoom') }}</th>
              <td v-html="$t('js.map_controls.help.zoom_html')" />
            </tr>
            <tr>
              <th>{{ $t('js.map_controls.help.zoom_on_area') }}</th>
              <td v-html="$t('js.map_controls.help.zoom_on_area_html')" />
            </tr>
            <tr>
              <th>{{ $t('js.map_controls.help.rotate') }}</th>
              <td v-html="$t('js.map_controls.help.rotate_html')" />
            </tr>
            <tr>
              <th>{{ $t('js.map_controls.help.pan') }}</th>
              <td v-html="$t('js.map_controls.help.pan_html')" />
            </tr>
          </tbody>
        </table>
        <!-- eslint-enable vue/no-v-html -->
      </rui-help-button>

      <rui-button :title="expanded ? $t('js.map_controls.hide_advanced_controls') : $t('js.map_controls.show_more_controls')"
                  :icon="expanded ? 'caret-circle-up' : 'more-dots'"
                  @click="expanded = !expanded" />
    </rui-toolbar>
  </div>
</template>

<script>
import RuiButton from '@experiments-labs/rise_ui/src/components/Button/Button.vue'
import RuiHelpButton from '@experiments-labs/rise_ui/src/components/HelpButton/HelpButton.vue'
import RuiToolbar from '@experiments-labs/rise_ui/src/components/Toolbar/Toolbar.vue'

import GardenMap from '../../classes/GardenMap'

/**
 * Buttons to control a `GardenMap` instance.
 *
 * @preset default { "props": { "gardenMap": { } }}
 *
 * @playgroundMinHeight 250px
 * @playgroundBackground checkboard
 */
export default {
  name: 'GpMapControls',
  components: { RuiToolbar, RuiHelpButton, RuiButton },
  props: {
    /** `GardenMap` instance. Can be `null` until it's created */
    gardenMap: { required: false, type: GardenMap, default: null },
  },
  data () {
    return {
      expanded: false,
    }
  },
}
</script>
